import { AppDetailsPopover } from './AppDetailsPopover';
import { AppDisplay } from './AppDisplay';
import { NotMonitoredLabel } from './NotMonitoredLabel';
import React from 'react';
import { Else, If, Then, When } from 'react-if';
import { Space, SpaceProps } from 'antd';

export interface AppListProps {
	appIds: Array<number>;
	direction: SpaceProps['direction'];
	showNotMonitored?: boolean
}

export const AppList: React.FC<AppListProps> = ({ appIds, direction, showNotMonitored }) => {
	if (!appIds.length) {
		return null;
	}

	return (
		<Space
			align='start'
			direction={ direction }
			size={ direction === 'horizontal' ? 0 : 4 }>
			<If condition={ appIds.length === 1 && appIds[ 0 ] === -1 }>
				<Then>
					<When condition={ showNotMonitored }>
						<NotMonitoredLabel />
					</When>
				</Then>
				<Else>
					{ appIds.map((appId) =>
						<AppDetailsPopover
							appId={ appId }
							key={ appId }>
							<AppDisplay appId={ appId } />
						</AppDetailsPopover>) }
				</Else>
			</If>
		</Space>
	);
};
